module.exports = __webpack_public_path__ + "img/welcome-page.7e60b2bf.webp";